import useWeakMap from "../../utils/useWeakMap"
import useQueryRootLayer from "../chain/store/useStoreRootLayer";
import useLogStack from "./useLogStack";
import { getParentLinking } from "./useMarkParentLinking";

const store = useWeakMap();

const doIncreaseLayer = (layer) => {
    let version = store.get(layer) || 0;
    version++;
    store.set(layer, version);
    useLogStack('doIncreaseLayer', layer, { version })
    return version;
}

const inscreaseRootLayerVersion = (layer) => {
    const rootLayer = useQueryRootLayer(layer);
    if (!rootLayer) return;
    doIncreaseLayer(rootLayer);
}

const increaseLinkingLayer = (layer) => {
    const linkingLayer = getParentLinking(layer);
    if (!linkingLayer) return;
    doIncreaseLayer(linkingLayer);
}

const useLayerVersioning = (layer) => {
    const version = doIncreaseLayer(layer);
    increaseLinkingLayer(layer)
    inscreaseRootLayerVersion(layer);
    return version
}


export const getLayerVersioning = (layer) => store.get(layer) || 0;

export default useLayerVersioning;